/**
 * P2-3 Fase 4B — evita doble submit en formularios clase React.
 */
export function isSubmitInProgress(loading) {
  return loading === true;
}
